import React from "react";
import { Image, ModelFiles } from "../ProductDetailPageResult";
import { Video } from "~/common/Store/models/Video";
import MediaViewerV2 from "~/common/MediaViewerV2";
import SocialShareSection from "../SocialShareSection";
interface ProductGallerySectionProps {
  productImages: Image[];
  isOutletTemplate: boolean;
  videos: Video[];
  modelFiles: ModelFiles | undefined;
  productImageDisclaimer: string;
  activeItemNumberIndex: number;
  title: string;
  minimalPageVersion: boolean | undefined;
  socialLink: string;
  socialTitle: string;
  titleSection?: boolean;
  youMayAlsoNeedUrl: string;
  isVirtualGroupMaster: boolean;
  showEverlivingProductPage: boolean;
}
export const ProductGallerySection = ({
  productImages,
  isOutletTemplate,
  videos,
  modelFiles,
  productImageDisclaimer,
  activeItemNumberIndex,
  title,
  minimalPageVersion,
  socialLink,
  socialTitle,
  titleSection,
  youMayAlsoNeedUrl,
  isVirtualGroupMaster,
  showEverlivingProductPage
}: Readonly<ProductGallerySectionProps>) => {
  const hasMedia = Boolean(productImages?.length > 0 || videos?.length > 0 || modelFiles);
  const displayAskButton = !isVirtualGroupMaster && !isOutletTemplate && !showEverlivingProductPage;
  return <section id="gallery" data-no-jquery aria-label="gallery" data-testid="pdp-gallery-section" data-sentry-component="ProductGallerySection" data-sentry-source-file="index.tsx">
      {hasMedia && <MediaViewerV2 alt="alt" images={productImages} videos={isOutletTemplate ? [] : videos} videoTitle="video title" modelFiles={modelFiles} productImageDisclaimer={productImageDisclaimer} activeItemNumberIndex={activeItemNumberIndex} title={title} styles={minimalPageVersion ? "bg-white border-gray-200 rounded border-solid border border-l-0 border-r-0 xs:border-l xs:border-r flex flex-wrap overflow-hidden p-5 relative md:mb-5 lt:mb-0 xl:flex-nowrap" : undefined} />}
      {!minimalPageVersion && <SocialShareSection url={`http://www.webstaurantstore.com${socialLink}`} media={`https://cdnimg.webstaurantstore.com/${productImages[0]?.large}`} description={socialTitle} hasGallery={hasMedia} titleSection={titleSection} youMayAlsoNeedUrl={youMayAlsoNeedUrl} displayAskButton={displayAskButton} />}
    </section>;
};